module.exports = __webpack_public_path__ + "static/media/mercedes_04.e83a158d.png";